import { createContext, useContext } from 'react';
import { Map as MapInstance } from 'mapbox-gl';

// The raw mapbox-gl Map, available to everything rendered inside <MapboxMap>
// once its style has loaded. react-map-gl's own context hands out a MapRef
// that deliberately hides setStyle, addLayer, removeLayer and
// setLayoutProperty; the property map's layer sorting and print styling call
// those directly.
export const MapContext = createContext<MapInstance | undefined>(undefined);

export const useMapInstance = () => useContext(MapContext);
